import { withRouter } from 'react-router';
import { withStations } from 'components/queries/GetStationsQuery';
import { withUser } from 'components/queries/GetUserQuery';
import ExchangeJourneySelection from './ExchangeJourneySelection';

export default withRouter(withUser(withStations(ExchangeJourneySelection)));
